import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import GoogleAnalyticsService from 'services/GoogleAnalyticsService'
import {isProd, isStg} from 'utils/envUtils'

const VirtualPageTracking = ({userId}) => {
  const location = useLocation()

  useEffect(() => {
    GoogleAnalyticsService.setExternalTrackingCookie()

    if ((isStg() || isProd()) && !window.OneTrust) {
      const handleOneTrustLoaded = () => {
        GoogleAnalyticsService.trackVirtualPageView(location, userId)
        window.removeEventListener('OneTrustLoaded', handleOneTrustLoaded)
      }

      window.addEventListener('OneTrustLoaded', handleOneTrustLoaded)
    } else {
      GoogleAnalyticsService.trackVirtualPageView(location, userId)
    }

    const handleOneTrustConsentChanged = () => {
      GoogleAnalyticsService.trackVirtualPageView(location, userId)
      window.removeEventListener('OneTrustConsentChanged', handleOneTrustConsentChanged)
    }

    window.addEventListener('OneTrustConsentChanged', handleOneTrustConsentChanged)
  }, [location, userId])

  return null
}

export default VirtualPageTracking
